import { BaseValidator } from '../BaseValidator';
import { ValidationRules } from '../ValidationRules';
import { ValidatorOptions } from '../types';

/**
 * String-specific validator with common string validation rules
 */
export class StringValidator extends BaseValidator<string> {
  constructor(options: ValidatorOptions = {}) {
    super(options);
  }

  /**
   * Add minimum length validation
   */
  minLength(min: number, message?: string): this {
    return this.addRule(ValidationRules.minLength(min, message));
  }

  /**
   * Add maximum length validation
   */
  maxLength(max: number, message?: string): this {
    return this.addRule(ValidationRules.maxLength(max, message));
  }

  /**
   * Add pattern validation
   */
  pattern(regex: RegExp, message?: string): this {
    return this.addRule(ValidationRules.pattern(regex, message));
  }

  /**
   * Add email format validation
   */
  email(message?: string): this {
    return this.addRule(ValidationRules.email(message));
  }

  /**
   * Add one-of validation (must be one of specified values)
   */
  oneOf(options: string[], message?: string): this {
    return this.addRule(ValidationRules.oneOf(options, message));
  }

  /**
   * Add custom validation
   */
  custom(validator: (value: string, context?: Record<string, unknown>) => boolean, message: string): this {
    return this.addRule(ValidationRules.custom(validator, message));
  }

  /**
   * Static factory methods for common use cases
   */
  static create(options?: ValidatorOptions): StringValidator {
    return new StringValidator(options);
  }

  static required(message?: string): StringValidator {
    return new StringValidator().required(message);
  }

  static email(message?: string): StringValidator {
    return new StringValidator().email(message);
  }

  static minLength(min: number, message?: string): StringValidator {
    return new StringValidator().minLength(min, message);
  }

  static maxLength(max: number, message?: string): StringValidator {
    return new StringValidator().maxLength(max, message);
  }

  static pattern(regex: RegExp, message?: string): StringValidator {
    return new StringValidator().pattern(regex, message);
  }
}